// Formatters are built once at module load. Constructing one per call is an order of magnitude
// more expensive and these run per row of long, endlessly scrolling lists.
const DATE_FORMAT = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'short', year: 'numeric' });
const DATE_TIME_FORMAT = new Intl.DateTimeFormat('de-DE', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(isoString?: string): string {
  if (!isoString) return '-';
  return DATE_FORMAT.format(new Date(isoString));
}

export function formatTimestamp(timestamp: number): string {
  return DATE_FORMAT.format(new Date(timestamp * 1000));
}

export function formDate(date: Date) {
  return DATE_FORMAT.format(date);
}

export function getDaysAgo(dateString: string): number {
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - date.getTime());
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function getWeeksAgo(dateString: string): number {
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - date.getTime());
  const diffWeeks = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks;
}

export function formatLastActive(dateString: string, t: (key: string, options?: Record<string, unknown>) => string): string {
  const daysAgo = getDaysAgo(dateString);
  const weeksAgo = getWeeksAgo(dateString);

  if (daysAgo === 0) {
    return t('common.today');
  }

  if (daysAgo === 1) {
    return t('common.yesterday');
  }

  if (weeksAgo === 1) {
    return t('common.lastWeek');
  }

  if (weeksAgo >= 2) {
    return t('common.weeksAgo', { count: weeksAgo });
  }

  return t('common.daysAgo', { count: daysAgo });
}


export function formatMinutesAsString(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0) {
    return `${hours}h ${mins}m`;
  }
  return `${mins}m`;
}


export function formatSecondsAsString(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
}

// formatDateTime renders an ISO timestamp as a localised date plus hour and minute.
export function formatDateTime(isoString?: string): string {
  if (!isoString) return '-';
  return DATE_TIME_FORMAT.format(new Date(isoString));
}
